'use client'

import { SelectPromotion } from 'analytics/components/SelectPromotion/SelectPromotion'
import cx from 'classix'
import dynamic from 'next/dynamic'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'

import styles from './PromotionalBannerCtas.module.css'
import type { PromotionalBannerCtasProps } from './PromotionalBannerCtasTypes'

const ClientLinkPrimary = dynamic(() =>
	import('@fukku/button/ClientLink/Primary/ClientLinkPrimary').then(
		(mod) => mod.ClientLinkPrimary
	)
)

export const DynamicPromotionalBannerCtas = ({
	ctas,
	isLow,
	isSingleCta,
}: PromotionalBannerCtasProps) => {
	const wrapperClassName = cx(
		styles.ctasWrapper,
		applyStylesIf(isLow, styles.low),
		applyStylesIf(isSingleCta, styles.singleCta)
	)
	const buttonClassName = cx(styles.ctaButton, applyStylesIf(isLow, styles.low))

	if (ctas.length === 1) {
		return (
			<div className={wrapperClassName}>
				{ctas.map((cta) => (
					<div key={cta.ctaId} className={buttonClassName}>
						{cta.text}
					</div>
				))}
			</div>
		)
	}

	return (
		<div className={wrapperClassName}>
			{ctas.map((cta) => (
				<SelectPromotion promotion={cta.promotion} key={cta.ctaId}>
					<ClientLinkPrimary
						href={cta.href}
						className={buttonClassName}
						linkProps={cta.linkProps}
						isLocalizedPath={cta.isLocalizedPath}
						data-testid='landings.home.promotionalBannerLink'
					>
						{cta.text}
					</ClientLinkPrimary>
				</SelectPromotion>
			))}
		</div>
	)
}
